var Translate = require('./components/translate');

var TranslateLink = require('./components/translate-link');

var LanguageSelector = require('./components/language-selector');

var useTranslations = require('./hooks/useTranslations');

var _require = require('./contexts/translate-context'),
    useTranslateContext = _require.useTranslateContext;

module.exports = {
  Translate: Translate,
  useTranslations: useTranslations,
  TranslateLink: TranslateLink,
  useTranslateContext: useTranslateContext,
  LanguageSelector: LanguageSelector
};